const lang = {
    public:{
        add:'Add',
        edit:"Edit",
        confirmDelete:'Confirm delete',
        delete:"Delete",
        multiDelete:'Multi Delete',
        hide:'Hide',
        save:'Save',
        close:'Close',
        screen:'Local screening'
    },
    key:{
        currentPathTips:'Key can only be a path that cannot be a value.',
        delConfirm:'Are you sure you want to delete the selected key?',
        notSubKey:'No child level list!',
        editKey:'Editor Key',
        addKey:'Add Key',
        open:'Open',
        show:'Show',
        keyNotEmpty:'Key can not be empty',
        addSuccessfully:'Added successfully!',
        saveSuccessfully:'Saved successfully!',
    },
    logs:{
        date:'Date',
        user:'User',
        typeof:'Type',
        filter:'Filter',
        selectDate:'Please select a date',
        selectDateShowLog:'Select date to view the log',
    },
    etcdServer:{
        repairDirectory:'Repair directory',
        determineRepairDirectory:'Determine the directory problem for repairing the etcd key',
    }

}

export default lang;
